module.exports = __webpack_public_path__ + "img/emoji_69.584c82bc.png";